<div class="report-telemetry-min-max-component">
  <table class="table table-sm table-striped master">
    <thead>
      <tr>
        @for (heading of days; track heading) {
          @if (heading.line1 === 'Sensor') {
            <th></th>
          }
          @if (heading.line1 !== 'Sensor') {
            <th colspan="2">
              {{ heading.line1 }}<br /><span class="day-line2">{{ heading.line2 }}</span>
            </th>
          }
        }
      </tr>
      <tr>
        @for (heading of days; track heading) {
          @if (heading.line1 === 'Sensor') {
            <th>{{ heading.line1 }}<br />{{ heading.line2 }}</th>
          }
          @if (heading.line1 !== 'Sensor') {
            <th colspan="1"><small>min</small></th>
          }
          @if (heading.line1 !== 'Sensor') {
            <th colspan="1"><small>max</small></th>
          }
        }
        @if (tableData && canAlert) {
          <th colspan="1">
            <span class="hidden-xs"><small>Performance</small></span>
          </th>
        }
      </tr>
    </thead>
    <tbody>
      @for (asset of tableData; track asset; let i = $index) {
        <tr [hidden]="selectedIndex !== null && selectedIndex !== i" (click)="drill(asset, i)">
          <td><i [hidden]="selectedIndex !== i" class="fa fa-chevron-left"></i> {{ asset.title }}</td>
          @for (value of asset.values; track $index) {
            <td [class.inRedAlert]="value.redMinAlert" [class.inOrangeAlert]="value.orangeMinAlert && !value.redMinAlert">
              <span class="pull-right"
                >{{ value.min }}
                @if (value?.min == null) {
                  <span>--.-</span>
                }
              </span>
              @if (canAlert) {
                <div>
                  <br />
                  @if (value?.min != null) {
                    <span class="range pull-right">{{ value.setpoint?.min | number: '1.1' }}</span>
                  }
                </div>
              }
            </td>
            <td [class.inRedAlert]="value.redMaxAlert" [class.inOrangeAlert]="value.orangeMaxAlert && !value.redMaxAlert">
              <span class="pull-right"
                >{{ value.max }}
                @if (value?.max == null) {
                  <span>--.-</span>
                }
              </span>
              @if (canAlert) {
                <div>
                  <br />
                  @if (value?.max != null) {
                    <span class="range pull-right">{{ value.setpoint?.max | number: '1.1' }}</span>
                  }
                </div>
              }
            </td>
          }
          @if (canAlert) {
            <td class="performance-column"><i class="fa fa-fw fa-circle" [class.inRedAlert]="asset.inRedAlert" [class.inOrangeAlert]="asset.inOrangeAlert && !asset.inRedAlert"></i></td>
          }
        </tr>
      }
    </tbody>
  </table>
  <!-- Drilldown details for mobile -->
  @if (selectedIndex !== null) {
    <div class="drilldown">
      <table class="table">
        <thead>
          <th>Day</th>
          @if (canAlert) {
            <th class="red">Setpoint<br />Red Min</th>
          }
          @if (canAlert) {
            <th class="amber">Setpoint<br />Amber Min</th>
          }
          <th>Min</th>
          <th>Max</th>
          @if (canAlert) {
            <th class="amber">Setpoint<br />Amber Max</th>
          }
          @if (canAlert) {
            <th class="red">Setpoint<br />Red Max</th>
          }
        </thead>
        <tbody>
          @for (value of tableData[selectedIndex].values; track value; let i = $index) {
            <tr>
              <td>
                <span class="day-line1">{{ days[i + 1].line1 }} </span><span class="day-line2">{{ days[i + 1].line2 }}</span>
              </td>
              @if (canAlert) {
                <td class="red">
                  @if (value?.min != null) {
                    <span class="pull-right">{{ value.setpoint?.red_min | number: '1.1' }}</span>
                  }
                </td>
              }
              @if (canAlert) {
                <td class="amber">
                  @if (value?.min != null) {
                    <span class="pull-right">{{ value.setpoint?.amber_min | number: '1.1' }}</span>
                  }
                </td>
              }
              <td class="value" [class.inRedAlert]="value.redMinAlert" [class.inOrangeAlert]="value.orangeMinAlert && !value.redMinAlert" (click)="showPopup()">
                <span class="pull-right"
                  >{{ value.min }}
                  @if (value?.min == null) {
                    <span>--.-</span>
                  }
                </span>
              </td>
              <td class="value" [class.inRedAlert]="value.redMaxAlert" [class.inOrangeAlert]="value.orangeMaxAlert && !value.redMaxAlert" (click)="showPopup()">
                <span class="pull-right"
                  >{{ value.max }}
                  @if (value?.max == null) {
                    <span>--.-</span>
                  }
                </span>
              </td>
              @if (canAlert) {
                <td class="amber">
                  @if (value?.min != null) {
                    <span class="pull-right">{{ value.setpoint?.amber_max | number: '1.1' }}</span>
                  }
                </td>
              }
              @if (canAlert) {
                <td class="red">
                  @if (value?.max != null) {
                    <span class="pull-right">{{ value.setpoint?.red_max | number: '1.1' }}</span>
                  }
                </td>
              }
            </tr>
          }
        </tbody>
      </table>
      @if (isShowingPopupSensorData) {
        <app-sensor-popup [showPoints]="true" [(show)]="isShowingPopupSensorData" [asset]="selectedAsset" [startsAt]="startsAt" [endsAt]="endsAt"></app-sensor-popup>
      }
    </div>
  }
</div>
